export default [
  {
    path: '/explore',
    name: 'tagSearch#index',
    component: () => import(/* webpackChunkName: "tagSearch/index" */ '@views/tag-search/index'),
    meta: {
      header: true,
      mastery: true,
      resourceOptional: true,
    },
  },
];
